import React from 'react';
import NoDataComponent from '../no-data/no-data';
import { useOutletContext } from 'react-router-dom';

function TableWidget(props) {
    const columns = props?.columns;
    const data = props?.data;
    //getting route context
    const {currencySign} = useOutletContext();

    return (
        <div className="table-responsive">
            <table className="table align-items-center ">
                <thead className='text-center prayers-table-header white'>
                    <tr>
                        {
                            columns.map((item, index) => {
                                return <th key={index}>{item}</th>
                            })
                        }
                    </tr>
                </thead>
                <tbody className='prayer-table-body text-center'>
                    {
                        data?.map((item, key) => {
                            return <tr key={key}>
                                <td>{item?.currency}</td>
                                <td>{currencySign}{item?.total_amount ? item?.total_amount : 0}</td>
                            </tr>
                        })
                    }

                </tbody>

            </table>

            {/* no data message */}
            {
                data?.length === 0 ?
                    <NoDataComponent message={'No Record Available'} /> : ''
            }

        </div>
    );
}

export default TableWidget;